"use strict";
exports.__esModule = true;
var react_1 = require("react");
var useIsomorphicLayoutEffect_1 = require("./useIsomorphicLayoutEffect");
function useEventCallback(fn) {
    var ref = react_1.useRef(function () {
        throw new Error('Function is called before it was assigned.');
    });
    useIsomorphicLayoutEffect_1["default"](function () {
        ref.current = fn;
    });
    return react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ref.current.apply(ref, args);
    }, []);
}
exports["default"] = useEventCallback;
